import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";
import { Plus, Trash2, Shield, ShieldCheck } from "lucide-react";

export default function UsersAdmin() {
  const [users, setUsers] = useState([]);
  const [form, setForm] = useState({ email: "", name: "", role: "editor" });
  const [loading, setLoading] = useState(true);

  const load = async () => { setLoading(true); try { const { data } = await api.get("/admin/users"); setUsers(data); } catch (e) { if (e?.response?.status === 403) toast.error("Apenas admin pode gerenciar usuários."); } setLoading(false); };
  useEffect(() => { load(); }, []);

  const add = async (e) => {
    e.preventDefault();
    try {
      await api.post("/admin/users", form);
      toast.success("Usuário criado.");
      setForm({ email: "", name: "", role: "editor" });
      load();
    } catch (err) { toast.error(err?.response?.data?.detail || "Erro."); }
  };

  const updateRole = async (u, role) => {
    await api.post("/admin/users", { email: u.email, name: u.name || "", role });
    toast.success("Permissão atualizada.");
    load();
  };

  const remove = async (email) => {
    if (!window.confirm(`Remover ${email}?`)) return;
    try {
      await api.delete(`/admin/users/${encodeURIComponent(email)}`);
      toast.success("Removido.");
      load();
    } catch (e) { toast.error(e?.response?.data?.detail || "Erro."); }
  };

  return (
    <div>
      <h1 className="font-display text-4xl mb-2">Usuários</h1>
      <p className="text-sm text-neutral-500 mb-8">Gerencie quem pode acessar o painel. Admin: tudo. Editor: edita conteúdo, sem gerenciar usuários/import.</p>

      <form onSubmit={add} className="border border-black/10 p-4 rounded mb-8 grid md:grid-cols-4 gap-3" data-testid="user-add-form">
        <input value={form.email} onChange={(e) => setForm({...form, email: e.target.value})} placeholder="email@dominio.com" data-testid="user-email" className="border border-black/15 px-3 py-2 rounded text-sm" required />
        <input value={form.name} onChange={(e) => setForm({...form, name: e.target.value})} placeholder="Nome (opcional)" className="border border-black/15 px-3 py-2 rounded text-sm" />
        <select value={form.role} onChange={(e) => setForm({...form, role: e.target.value})} data-testid="user-role" className="border border-black/15 px-3 py-2 rounded text-sm bg-white">
          <option value="editor">Editor</option><option value="admin">Admin</option>
        </select>
        <button type="submit" data-testid="user-add" className="bg-accent-yellow text-black font-semibold text-sm px-4 py-2 rounded-full"><Plus className="w-3 h-3 inline mr-1" /> Convidar</button>
      </form>

      <div className="space-y-2" data-testid="users-list">
        {loading ? <div className="text-sm text-neutral-500">Carregando…</div> : users.map((u) => (
          <div key={u.email} className="flex items-center gap-3 border border-black/10 p-3 rounded">
            <div className="w-9 h-9 rounded-full bg-neutral-200 overflow-hidden flex-shrink-0">{u.picture && <img src={u.picture} alt="" className="w-full h-full object-cover" />}</div>
            <div className="flex-1 min-w-0"><div className="font-semibold truncate">{u.name || u.email}</div><div className="text-xs text-neutral-500">{u.email}</div></div>
            <select value={u.role || "editor"} onChange={(e) => updateRole(u, e.target.value)} className="text-xs border border-black/15 px-2 py-1.5 rounded bg-white"><option value="editor">Editor</option><option value="admin">Admin</option></select>
            {u.role === "admin" ? <ShieldCheck className="w-4 h-4 text-accent-green" /> : <Shield className="w-4 h-4 text-neutral-400" />}
            <button onClick={() => remove(u.email)} className="text-xs text-red-500 px-2"><Trash2 className="w-3 h-3" /></button>
          </div>
        ))}
        {!loading && !users.length && <div className="text-sm text-neutral-500 text-center py-12">Nenhum usuário ainda.</div>}
      </div>
    </div>
  );
}
